<template>
  <div class="dialog-app-panel" :class="showDetails ? 'dialog-show' : ''">
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="showDetails"
      title="报告详情"
      @cancel="close"
    >
      <el-radio-group v-model="activeName" style="margin-bottom: 16px">
        <el-radio-button label="first">报告详情</el-radio-button>
        <el-radio-button label="second">执行明细</el-radio-button>
      </el-radio-group>
      <div class="content" v-show="activeName == 'first'">
        <div>
          <span class="label">抓拍图片</span>
          <div
            v-if="reportDetails.length > 0"
            style="overflow: auto; height: 100px"
          >
            <div
              v-for="(item, index) in reportDetails"
              :key="index"
              style="display: inline-block; width: 22%; margin: 10px 3% 10px 0"
            >
              <img
                :src="item"
                alt=""
                style="width: 100%; height: 70px;cursor:pointer"
                @click="showViewer(item, $event)"
              />
            </div>
          </div>
          <div v-else style="padding: 20px; text-align: center">暂无图片</div>
        </div>
        <div>
          <el-form :model="ruleForm" ref="ruleForm">
            <el-form-item prop="textarea">
              <span class="label">报告内容</span>
              <div>
                <el-input
                  type="textarea"
                  :rows="5"
                  :readonly="!btn"
                  :maxlength="200"
                  :show-word-limit="true"
                  v-model="textarea"
                >
                </el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="content" v-show="activeName == 'second'">
        <div style="padding: 15px 0 0 20px; max-height: 400px; overflow: auto">
          <el-timeline direction="vertical">
            <el-timeline-item
              v-for="(item, index) in stepList"
              :key="index"
              type="primary"
              :timestamp="
                item.operateTime
                  ? getTime(item.operateTime, 'yyyy-MM-dd hh:mm:ss')
                  : ''
              "
            >
              {{ item.type | dic("SENU073007") }}
              <template>
                <div style="position: absolute; left: 100px; top: 0px">
                  <span
                    style="border: none; color: #00e8bb; cursor: pointer"
                    v-if="item.type && item.type != '99' && item.type != '-1'"
                    @click.stop="getDetailsLists(item)"
                    >详情</span
                  >
                </div>
              </template>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" v-if="btn" @click="submitData"
          >提交报告</el-button
        >
        <el-button type="info" v-if="btn" @click="close">取消</el-button>
        <el-button type="info" v-else @click="close">关闭</el-button>
      </div>
    </appPanel>
    <!-- 执行步骤详情 -->
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="showStepDetails"
      title="详情"
      @cancel="handleCloseStep"
    >
      <ioc-table
        v-if="showStepDetails"
        style="height: 400px"
        :data="stepHistoryList"
        :option="stepOptionList"
        :page="pageDetails"
        @size-change="sizeChangeDetails"
        @current-change="pageChangeDetails"
      >
        <template slot="图片" slot-scope="scope">
          <img
            :src="scope.row.图片"
            @click="showViewer(scope.row.图片, $event)"
            onerror="this.src='/images/theme/newDark/default.png'"
            style="height: 25px; width: 50px;cursor: pointer;"
          />
        </template>
      </ioc-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="handleCloseStep">关闭</el-button>
      </div>
    </appPanel>
    <!--  -->
  </div>
</template>
<script>
import { formatTimeToStr } from "../filter/dateUtils";
import { Bus } from "$utils";
import { api } from "../api";
import utils from "@src/common/utils";
import stepOption from "../const/step";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  name: "reserveRecordDetails",
  components: {
    appPanel,
  },
  props: {
    btn: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    title: {
      type: String,
      default: () => {
        return "";
      },
    },
    textarea: {
      type: String,
      default: () => {
        return "";
      },
    },
    reportDetails: {
      type: Array,
      default: () => {
        return [];
      },
    },
    stepList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      Bus,
      ruleForm: {
        textarea: "",
      },
      text: "",
      stepHistoryList: [],
      stepOptionList: {},
      showDetails: false,
      activeName: "first",
      reportDetails1: [],
      showStepDetails: false,
      pageDetails: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
    };
  },
  methods: {
    sizeChangeDetails(pageSize) {
      // this.$fetch(api.getSubRecordDetail, {
      //   pageNum: this.pageDetails.currentPage,
      //   pageSize: pageSize,
      //   emergencyProcessID: this.paramsData.emergencyProcessID,
      // }).then((res) => {
      //   this.pageDetails.total = res.returnObj.total;
      //   this.stepHistoryList = res.returnObj.list;
      // });
    },
    pageChangeDetails(pageNo) {
      // this.$fetch(api.getSubRecordDetail, {
      //   pageNum: pageNo,
      //   pageSize: this.pageDetails.pageSize,
      //   emergencyProcessID: this.paramsData.emergencyProcessID,
      // }).then((res) => {
      //   this.pageDetails.total = res.returnObj.total;
      //   this.stepHistoryList = res.returnObj.list;
      // });
    },
    handleCloseStep() {
      this.showStepDetails = false;
    },
    showViewer(src, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    close() {
      this.showDetails = false;
      this.activeName = "first";
    },
    submitData() {
      this.$emit("submitData", this.textarea);
    },
    getTime(time, type) {
      return formatTimeToStr(time, type);
    },
    callback(data) {
      // 原先数据结构
      // [{
      // 操作人: "叶海军"
      // 操作时间: "2021-04-30 16:25:45"
      // 新级别: "Ⅱ级"
      // 旧级别: "Ⅰ级"
      // }]
      let ary = [];
      data.map((val, index) => {
        // 拿第一个对象的属性
        if (index == 0) {
          for (const key in val) {
            let obj = {};
            obj["label"] = key;
            obj["prop"] = key;
            obj["search"] = false;
            obj["span"] = 12;
            ary.push(obj);
          }
        }
      });
      this.showStep(ary, data);
      // this.$emit("handleShowStepDetails", ary, data);
    },
    showStep(ary, data) {
      this.showStepDetails = true;
      this.stepOptionList = stepOption(ary);
      this.stepHistoryList = data ? data : [];
    },
    getDetailsLists(data) {
      this.$fetch(api.getSubRecordDetail, {
        emergencySubRecordCode: data.emergencySubRecordCode,
      }).then((res) => {
        if (res.success) {
          if (!res.returnObj) {
            this.$message.warning("暂无数据，稍后再试");
            return;
          }
          // 返回格式化数据
          this.callback(res.returnObj);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.content {
  padding: 16px;
  border-radius: 5px;
  @include set_theme_color(background-color, dialog-main-bg-color);
  .label {
    font-size: 14px;
    width: 100px;
    height: 28px;
  }
}
.reserve-record-details {
  .elePatrol {
    width: 100%;
    height: 100%;
  }
  .el-step__description.is-success {
    color: #00e8bb;
  }
  .el-step__head.is-success {
    border-color: #00e8bb;
  }
  li {
    list-style: none;
  }
}
</style>
